import { render, staticRenderFns } from "./QrCodeReader.vue?vue&type=template&id=36c7ad74&scoped=true"
import script from "./QrCodeReader.vue?vue&type=script&lang=js"
export * from "./QrCodeReader.vue?vue&type=script&lang=js"
import style0 from "./QrCodeReader.vue?vue&type=style&index=0&id=36c7ad74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7ad74",
  null
  
)

export default component.exports